import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import InventoryCarCard from "./component";
import { fetchCarDetails, fetchLeadAppointment } from "../car-details/actions";
import { createClassifiedLead, saveCheckoutSourcePathname } from "../checkout-info/actions";
import { openLoginPopup, setLoginType } from "../../au.configuration/actions";
import withLogin from "../with-login";
import { setVideoGalleryModalOpen } from "../video-gallery/actions";
import {getDealerInfo} from "../dealer-page-components/actions";

const mapStateToProps = ({
    user: {email, isGuestLogin, phoneNumberVerified },
    filters: {
        allFilters,
        appliedFilters,
        selectedSort,
        listingType
    },
    config: {
        saleConfig,
        testDriveConfig,
        classifiedConfig
    },
    tradeIn: {
        userTradeInData,
        tradeInToggleSelected
    },
    user: {
        isUserZeroDpVariant
    },
    abExperiment: {
        showTestDriveV2,
        webPriceDropDesktop,
        galleryOnTheFlyDesktop,
        desktopCarCard,
        desktopWishlistAdoption,
        webCarTour,
        desktopCtaOptimization,
        stagingDealerBadge,
        desktopLuxuryCars
    },
    carListing: {
        metaContent,
        cmsConfig
    },
    dealer: {
        dealerInfo
    },
    carDetails: {
        leadAppointment
    },
    cmsConfig: globalCmsConfig

}) => ({
    allFilters,
    appliedFilters,
    selectedSort,
    saleConfig,
    userTradeInData,
    tradeInToggleSelected,
    email,
    listingType,
    isUserZeroDpVariant,
    showTestDriveV2,
    isGuestLogin,
    webPriceDropDesktop,
    galleryOnTheFlyDesktop,
    testDriveConfig,
    desktopCarCard,
    desktopWishlistAdoption,
    webCarTour,
    desktopCtaOptimization,
    phoneNumberVerified,
    metaContent,
    cmsConfig,
    dealerInfo,
    classifiedConfig,
    leadAppointment,
    globalCmsConfig,
    stagingDealerBadge,
    desktopLuxuryCars
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCarDetailsConnect: fetchCarDetails,
    saveCheckoutSourcePathnameConnect: saveCheckoutSourcePathname,
    setLoginTypeConnect: setLoginType,
    setVideoGalleryModalOpenConnect: setVideoGalleryModalOpen,
    openLoginPopupConnect: openLoginPopup,
    createClassifiedLeadConnect: createClassifiedLead,
    getDealerInfoConnect: getDealerInfo,
    fetchLeadAppointmentConnect: fetchLeadAppointment
}, dispatch);

export default withLogin(withRouter(connect(mapStateToProps, mapDispatchToProps)(InventoryCarCard)));
